@import '../../styles/fonts';
@import '../../styles/palette';
@import '../../styles/deviceBreakpoints';

.container {
  margin-bottom: 1.875rem;
  margin-top: 0.75rem;

  p {
    max-width: 25rem;

    &.pictureUploadLabel {
      span {
        display: block;

        &.pictureDescriptionMargin {
          margin-top: 0.7rem;
        }
      }
    }
  }

  .pictureContainer {
    background-color: white;
    border: 0.125em solid _palette(input-border-outlined);
    height: 100%;
    margin-right: 1.2rem;
    max-width: 50rem;
    min-height: 28rem;
    overflow: hidden;
    position: relative;

    @include target(md) {
      margin-right: 0;
      min-height: 20rem;
    }

    .profilePicture {
      left: 50%;
      min-height: 100%;
      width: 100%;
      object-fit: cover;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);

      &.editMode {
        opacity: 0.7;
      }
    }
  }

  .pictureFileUpload {
    background-color: _palette(profile-picture-overlay);
    border-radius: 0;
    height: 100%;
    position: absolute;

    &:hover {
      background-color: #d6eff6ee !important;
    }
  }

  .profilePictureReplacement {
    align-items: center;
    background-color: _palette(profile-picture-bg);
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    width: 100%;

    .iconWrapper {
      background-color: _palette(bg-secondary);
      border-radius: 50%;
      height: 3.125rem;
      margin-bottom: 5%;
      width: 3.125rem;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        background-color: _palette(bg-secondary);
        margin: auto;
      }
    }
  }

  .info {
    background-color: _palette(card);
    border: 0.0625rem solid _palette(input-border-outlined);
    min-height: 20rem;
    padding: 1.25rem;
    position: relative;

    .practicePlaceName,
    .orgnr {
      margin-bottom: 0.625rem;
    }

    .label {
      font-size: 0.9375rem;
      font-weight: 600;
    }
  }

  .editProfileButtonContainer {
    display: flex;
    position: relative;
    margin-top: 1em;
    width: 100%;
    justify-content: flex-end;
  }

  textarea {
    height: 9.5rem;
    padding: 0.25rem;
    width: 100%;
  }

  .lastEditedBy {
    margin-top: 2em;
  }
}

.editProfileModal {
  width: 60%;

  @include target(md) {
    width: 80%;
  }

  @include target(tablet) {
    width: 95%;
  }
}

.praksisstedCardWrapper {
  margin-top: 2.5rem;

  > div {
    padding-bottom: 2.5rem;
  }

  .praksissted {
    background-color: _palette(card);
    border-radius: 0.75rem;
    box-shadow: 0.5rem 0.5rem 1rem #ccc;
    max-width: 331.5rem;
    min-height: 19rem;
    position: relative;

    .profilePicture img {
      border-radius: 0.75rem 0.75rem 0 0;
      height: 16.25rem;
      object-fit: cover;
      width: 100%;
    }

    .replacementPicture {
      background-color: _palette(profile-picture-bg);
      border-radius: 0.75rem 0.75rem 0 0;
      height: 16.25rem;
      padding-left: calc(50% - 3.75rem);
      padding-top: 4.75rem;
      position: relative;

      .iconWrapper {
        background-color: white;
        border-radius: 50%;
        height: 7.5rem;
        position: absolute;
        width: 7.5rem;
      }

      svg {
        background-color: white;
        height: 4.375rem;
        margin: 1.5rem;
        width: 4.375rem;
      }
    }

    .text {
      @include barlow(14);
      padding: 0.625rem;

      a {
        color: _palette(secondary);
      }

      .avdelingsnavn {
        @include barlow(16);
        font-weight: 600;
      }

      .readMoreLink {
        font-weight: 600;
      }
    }
  }
}

.practicePlaceHeader {
  h2 {
    span {
      color: _palette(secondary) !important;
    }
  }
}
